import { Component, inject, OnInit, TemplateRef, OnDestroy } from '@angular/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import {
  EnterpriseSearchService,
  WithSubscriptionComponent
} from '@sabstravtech/obtservices/angular';
import { faSliders } from '@fortawesome/pro-regular-svg-icons';
import { Router } from '@angular/router';

@Component({
  selector: 'app-filters-slider',
  templateUrl: './filters-slider.component.html',
  styleUrls: ['./filters-slider.component.scss'],
  standalone: false
})
export class FiltersSlider extends WithSubscriptionComponent implements OnInit, OnDestroy {
  private offcanvasService = inject(NgbOffcanvas);
  sliderIcon = faSliders;
  sliderOpen = false;
  openedContent: TemplateRef<any>;

  constructor(
    public searchService: EnterpriseSearchService,
    private router: Router
  ) {
    super();
    this.subscribe(router.events, () => {
      if (this.sliderOpen) {
        this.close(this.openedContent);
      }
    });
  }

  ngOnInit() {}

  open(content: TemplateRef<any>) {
    if (this.sliderOpen) {
      this.offcanvasService.dismiss(content);
      this.openedContent = null;
      this.sliderOpen = false;
    } else {
      this.offcanvasService.open(content, { position: 'end', scroll: true, backdrop: 'static' });
      this.openedContent = this.openedContent;
      this.sliderOpen = true;
    }
  }

  close(content: TemplateRef<any>) {
    this.offcanvasService.dismiss(content);
    this.sliderOpen = false;
    this.openedContent = null;
  }

  ngOnDestroy(): void {
    if (this.sliderOpen) {
      this.close(this.openedContent);
    }
  }
}
